(function(){
  function moeda(c){try{return (c/100).toLocaleString('pt-BR',{style:'currency',currency:'BRL'})}catch(e){return 'R$ '+(c/100).toFixed(2)}}
  function mascara(v){v=(v||'').replace(/\D/g,'').slice(0,8);return v.length>5?v.slice(0,5)+'-'+v.slice(5):v}
  function prazo(r){
    if(!r||r.length!==2)return '';
    var hoje=new Date();hoje.setHours(0,0,0,0);
    var a=Math.round((new Date(r[0]+'T00:00:00')-hoje)/86400000);
    var b=Math.round((new Date(r[1]+'T00:00:00')-hoje)/86400000);
    if(isNaN(a)||isNaN(b))return '';
    if(a===b)return a+(a===1?' dia':' dias');
    return a+' a '+b+' dias';
  }
  var FAIXAS=[[1000,19999,'São Paulo'],[20000,28999,'Rio de Janeiro'],[29000,29999,'Espírito Santo'],[30000,39999,'Minas Gerais'],[40000,48999,'Bahia'],[49000,49999,'Sergipe'],[50000,56999,'Pernambuco'],[57000,57999,'Alagoas'],[58000,58999,'Paraíba'],[59000,59999,'Rio Grande do Norte'],[60000,63999,'Ceará'],[64000,64999,'Piauí'],[65000,65999,'Maranhão'],[66000,68899,'Pará'],[68900,68999,'Amapá'],[69000,69299,'Amazonas'],[69300,69399,'Roraima'],[69400,69899,'Amazonas'],[69900,69999,'Acre'],[70000,72799,'Distrito Federal'],[72800,72999,'Goiás'],[73000,73699,'Distrito Federal'],[73700,76799,'Goiás'],[76800,76999,'Rondônia'],[77000,77999,'Tocantins'],[78000,78899,'Mato Grosso'],[79000,79999,'Mato Grosso do Sul'],[80000,87999,'Paraná'],[88000,89999,'Santa Catarina'],[90000,99999,'Rio Grande do Sul']];
  function estado(cep){var n=parseInt(cep.slice(0,5),10);for(var i=0;i<FAIXAS.length;i++){if(n>=FAIXAS[i][0]&&n<=FAIXAS[i][1])return FAIXAS[i][2]}return ''}
  async function calcular(box){
    var input=box.querySelector('[data-jbfr-cep]');
    var res=box.querySelector('[data-jbfr-res]');
    var btn=box.querySelector('[data-jbfr-calc]');
    var cep=(input.value||'').replace(/\D/g,'');
    if(cep.length!==8){res.innerHTML='<p class="jbfr__nota">Digite um CEP com 8 números.</p>';return}
    btn.disabled=true;var rotulo=btn.textContent;btn.textContent='Calculando…';res.innerHTML='';
    try{
      try{localStorage.setItem('jb_cep',mascara(cep))}catch(e){}
      var id=box.getAttribute('data-jbfr-variante');
      var carrinho=await (await fetch('/cart.js')).json();
      var tem=(carrinho.items||[]).some(function(i){return String(i.id)===String(id)});
      var adicionou=false;
      if(!tem&&id){
        await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})});
        adicionou=true;
      }
      var uf=estado(cep);
      var u='/cart/shipping_rates.json?shipping_address%5Bzip%5D='+encodeURIComponent(cep)+'&shipping_address%5Bcountry%5D=Brazil'+(uf?'&shipping_address%5Bprovince%5D='+encodeURIComponent(uf):'');
      var j=await (await fetch(u)).json();
      var taxas=(j&&j.shipping_rates)||[];
      if(!taxas.length){
        res.innerHTML='<p class="jbfr__nota">Não encontramos opções de entrega para este CEP. Confira o número, por favor.</p>';
      }else{
        var html=taxas.map(function(t){
          var c=Math.round(parseFloat(t.price)*100);
          var valor=c===0?'<b class="jbfr__gratis">grátis</b>':'<b>'+moeda(c)+'</b>';
          var p=prazo(t.delivery_range);
          return '<div class="jbfr__op"><span>'+t.name+(p?' · '+p:'')+'</span>'+valor+'</div>';
        }).join('');
        if(adicionou)html+='<p class="jbfr__nota">Adicionamos o produto ao seu carrinho para calcular o frete.</p>';
        res.innerHTML=html;
      }
      if(adicionou)atualizarContador();
    }catch(e){
      res.innerHTML='<p class="jbfr__nota">Não conseguimos calcular agora. Tente de novo em instantes.</p>';
    }
    btn.disabled=false;btn.textContent=rotulo;
  }
  async function atualizarContador(){
    try{
      var c=await (await fetch('/cart.js')).json();
      document.querySelectorAll('[data-cart-count],.hdt-cart-count,hdt-cart-count').forEach(function(e){e.textContent=c.item_count});
      document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart:c}}));
      document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true,detail:{cart:c}}));
    }catch(e){}
  }
  function ligar(box){
    if(box.__jbLigado)return;box.__jbLigado=true;
    var input=box.querySelector('[data-jbfr-cep]');
    var btn=box.querySelector('[data-jbfr-calc]');
    if(!input||!btn)return;
    try{var s=localStorage.getItem('jb_cep');if(s)input.value=mascara(s)}catch(e){}
    input.addEventListener('input',function(){input.value=mascara(input.value)});
    input.addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();calcular(box)}});
    btn.addEventListener('click',function(){calcular(box)});
  }
  function iniciar(){document.querySelectorAll('[data-jbfr]').forEach(ligar)}
  if(document.readyState!=='loading'){iniciar()}else{document.addEventListener('DOMContentLoaded',iniciar)}
  document.addEventListener('shopify:section:load',iniciar);
})();

(function(){
  function fechaTodos(exceto){
    document.querySelectorAll('[data-jbpol]').forEach(function(w){
      if(w===exceto)return;
      var c=w.querySelector('[data-jbpol-caixa]');var b=w.querySelector('[data-jbpol-abre]');
      if(c){c.hidden=true}if(b){b.setAttribute('aria-expanded','false')}
    });
  }
  function ligar(w){
    if(w.__jbPolLigado)return;w.__jbPolLigado=true;
    var b=w.querySelector('[data-jbpol-abre]');var c=w.querySelector('[data-jbpol-caixa]');
    var x=w.querySelector('[data-jbpol-fecha]');
    if(!b||!c)return;
    b.addEventListener('click',function(e){e.stopPropagation();var abrir=c.hidden;fechaTodos(w);c.hidden=!abrir;b.setAttribute('aria-expanded',abrir?'true':'false')});
    if(x)x.addEventListener('click',function(e){e.stopPropagation();c.hidden=true;b.setAttribute('aria-expanded','false');b.focus()});
    c.addEventListener('click',function(e){e.stopPropagation()});
  }
  function iniciar(){document.querySelectorAll('[data-jbpol]').forEach(ligar)}
  document.addEventListener('click',function(){fechaTodos(null)});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')fechaTodos(null)});
  if(document.readyState!=='loading'){iniciar()}else{document.addEventListener('DOMContentLoaded',iniciar)}
  document.addEventListener('shopify:section:load',iniciar);
})();
